import { useEffect, useRef } from 'react';
import { useSession } from '@/features/auth/context/SessionContext';
import { ACTION_TRACKED } from '@/libs/mixpanel';
import { useMixpanel } from './useMixpanel';

export function useAuthTracking() {
  const { status, user } = useSession();
  const previousStatusRef = useRef(status);
  const identify = useMixpanel((state) => state.identify);
  const trackAction = useMixpanel((state) => state.trackAction);
  const reset = useMixpanel((state) => state.reset);

  useEffect(() => {
    const previousStatus = previousStatusRef.current;

    // Handle user identification and login tracking
    if (status === 'signed-in' && user) {
      const userId = user.id || user.email;

      if (userId) {
        identify(userId, {
          email: user.email,
          name: user.name,
          ...(user.picture && { avatar: user.picture }),
        });
      }

      // Track login event if user just signed in
      if (previousStatus === 'signed-out' || previousStatus === 'in-progress') {
        trackAction(ACTION_TRACKED.USER_LOGIN);
      }
    } else if (status === 'signed-out' && previousStatus === 'signed-in') {
      trackAction(ACTION_TRACKED.USER_LOGOUT);
      reset();
    }

    previousStatusRef.current = status;
  }, [status, user, identify, trackAction, reset]);
}
